// PPCE's own Cognito client (authorization code + PKCE).
// The hub and the navbar never hand out tokens, so PPCE signs in itself. A user who
// is already signed in on the hub has a Cognito session, so the redirect comes straight back.
import { UserManager } from 'oidc-client-ts'

import { COGNITO_AUTHORITY, COGNITO_CLIENT_ID, COGNITO_SCOPE } from '../config/api'

// Cognito currently has <origin>/login registered, so /login also finishes the sign-in.
// Switch to '/auth' (route already exists) once that callback is registered.
export const CALLBACK_PATH = '/login'

const userManager = new UserManager({
  authority: COGNITO_AUTHORITY,
  client_id: COGNITO_CLIENT_ID,
  redirect_uri: `${window.location.origin}${CALLBACK_PATH}`,
  response_type: 'code',
  scope: COGNITO_SCOPE,
  // Tokens are renewed on demand in tokenSource with the refresh token.
  // Cognito doesn't allow the iframe-based renew this would otherwise fall back to.
  automaticSilentRenew: false,
  loadUserInfo: false,
})

export default userManager
